import { Suspense } from "react";
import {
  LoaderFunction,
  NonIndexRouteObject,
  redirect,
} from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { App } from "./App";
import {
  APP_LAYOUT_ID,
  LoaderContext,
  LoaderData,
  getAuthContext,
  getForwardingParams,
  routes,
  shouldRedirectToSignIn,
} from "./App.Parts";

// LOADER
const AppLoader: LoaderFunction<LoaderContext> = ({
  request,
  context,
}): Response | LoaderData => {
  const url = new URL(request.url);
  if (shouldRedirectToSignIn(url)) return redirect(routes.signIn + url.search);

  const params = getForwardingParams(url.searchParams);
  context.auth = getAuthContext(params);

  return { getAuthContext: context.auth };
};

// WRAPPER
const AppWrapper = () => (
  <Suspense fallback={<LoadingSplash />}>
    <App />
  </Suspense>
);

// LAYOUT
export const AppLayout: NonIndexRouteObject = {
  id: APP_LAYOUT_ID,
  errorElement: <GeneralErrorPage />,
  Component: AppWrapper,
  loader: AppLoader,
};
